module.exports = __webpack_public_path__ + "../resources/img/ic-layout-mapping.96bae00b.svg";